class CookieOperation {
  get (name) {
    let c = document.cookie.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`))
    return c ? c[2] : undefined
  }

  set (name, value, day = null) {
    if (day) {
      document.cookie = `${name}=${value}; expires=${day}; path=/`
    } else {
      document.cookie = `${name}=${value}; path=/`
    }
  }

  remove (name) {
    // 获取当前时间
    let date = new Date()
    // 将date设置为过去的时间
    date.setTime(date.getTime() - 10000)
    document.cookie = `${name}=; expires=${date.toGMTString()}`
  }

  getTenantId () {
    // developer的tenantId是存放在路径上的
    let reg = new RegExp('(^|&)tenantId=([^&]*)(&|$)', 'i')
    let r = window.location.search.substr(1).match(reg)
    if (r != null) {
      return unescape(r[2])
    }
    return this.get('tenantId') || null
  }
}

export default new CookieOperation()



// WEBPACK FOOTER //
// ./src/plugins/cookie/index.js